<template>
    <div class="monthly-report-print">
        <div class="report__header">
            <h3 class="header__title">월간 분석리포트 - {{ monthlyReportData.AnalysisResult.issueDate }}</h3>
        </div>
        <section class="report__overview">
            <div class="overview__info">
                <span class="info__grade">{{ comSchoolAndGrade }}</span>
                <p class="info__title">
                    {{ gStore.userInfo.studentName }}님의<br />
                    {{ monthlyReportData.AnalysisResult.issueDate }} <span class="emphasis">독해력은 {{ monthlyReportData.AnalysisResult?.totalAccuracyRate }}%</span>이고<br />
                    <span class="emphasis" v-if="monthlyReportData.AnalysisResult.caleAccuracyRate >= 0 || Number.isNaN(monthlyReportData.AnalysisResult.caleAccuracyRate)"
                        >전월 대비 {{ Number.isNaN(monthlyReportData.AnalysisResult.caleAccuracyRate) ? monthlyReportData.AnalysisResult.totalAccuracyRate : monthlyReportData.AnalysisResult.caleAccuracyRate }}% 상승</span
                    >
                    <span class="emphasis" v-if="monthlyReportData.AnalysisResult.caleAccuracyRate < 0">전월 대비 {{ Math.abs(monthlyReportData.AnalysisResult.caleAccuracyRate) }}% 감소</span>했습니다.
                </p>
                <span class="info__date">분석 기간 : {{ monthlyReportData.AnalysisResult.caleDate }}</span>
            </div>
            <div>
                <div class="overview__chart">
                    <div class="gauge-chart__wrap">
                        <div class="gauge-chart">
                            <GaugeChart v-if="monthlyReportData.AnalysisResult?.totalAccuracyRate" :chartData="monthlyReportData.AnalysisResult?.totalAccuracyRate" :label="monthlyReportData.AnalysisResult?.totalAccuracyRate" />
                        </div>
                        <div class="gauge-chart__data">
                            <span class="gauge-chart__title">독해력<span class="gauge-chart__title__star">*</span></span>
                            <span class="gauge-chart__percent"
                                ><span class="gauge-chart__percent__emphasis">{{ monthlyReportData.AnalysisResult?.totalAccuracyRate }}</span
                                >%</span
                            >
                        </div>
                    </div>
                    <div class="chart__info">
                        <dt>전월 대비</dt>
                        <dd>
                            <span class="emphasis" v-if="monthlyReportData.AnalysisResult.caleAccuracyRate >= 0 || Number.isNaN(monthlyReportData.AnalysisResult.caleAccuracyRate)"
                                >{{ Number.isNaN(monthlyReportData.AnalysisResult.caleAccuracyRate) ? monthlyReportData.AnalysisResult.totalAccuracyRate : monthlyReportData.AnalysisResult.caleAccuracyRate }}% 상승</span
                            >
                            <span class="emphasis" v-if="monthlyReportData.AnalysisResult.caleAccuracyRate < 0">{{ Math.abs(monthlyReportData.AnalysisResult.caleAccuracyRate) }}% 감소</span>
                        </dd>
                    </div>
                </div>
                <div class="overview__keyword">
                    <span class="keyword__title"><span class="keyword__star">*</span>독해력이란?</span>
                    지문을 적정 시간에 정확하게 읽고,<br />이해하여 문제를 해결할 수 있는 능력
                </div>
            </div>
        </section>
        <section class="report__section analyze-result">
            <h3 class="report__section__title">월간 분석 결과</h3>
            <div class="analyze-result__data">
                <dl class="data__list">
                    <dt class="data__title">독해력 성취율</dt>
                    <dd class="data">
                        <span class="emphasis">{{ monthlyReportData.AnalysisResult?.totalAccuracyRate }}%</span> / 100%
                    </dd>
                </dl>
                <dl class="data__list">
                    <dt class="data__title">학습한 지문 수</dt>
                    <dd class="data">
                        <span class="emphasis">{{ monthlyReportData.AnalysisResult?.passageCount }}지문</span>
                    </dd>
                </dl>
                <dl class="data__list">
                    <dt class="data__title">학습한 문항 수</dt>
                    <dd class="data">
                        <span class="emphasis">{{ monthlyReportData.AnalysisResult?.correctCount }}문항</span>
                    </dd>
                </dl>
                <dl class="data__list">
                    <dt class="data__title">평균 KReaD지수</dt>
                    <dd class="data">
                        <span class="emphasis">{{ monthlyReportData.AnalysisResult?.averageKreadScore }}</span>
                    </dd>
                </dl>
            </div>
            <p class="analyze-result__text">
                {{ monthlyTotalResult }}
            </p>
        </section>

        <section class="report__section learning-table">
            <h3 class="report__section__title">월간 학습 내역</h3>
            <table class="learning-table">
                <thead>
                    <tr>
                        <th>영역 주제</th>
                        <th>독해력</th>
                        <th style="text-align: left">갈래 / 주제</th>
                        <th>학습 지문수</th>
                        <th>평균 성취율</th>
                        <th style="text-align: right">평균 학습 시간</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td rowspan="5">문학</td>
                        <td rowspan="5">
                            <span class="emphasis">{{ monthlyReportData.LiteratureData.accuracyRate == null ? '-' : monthlyReportData.LiteratureData.accuracyRate + '%' }}</span>
                        </td>
                        <td style="text-align: left">현대시</td>
                        <td>{{ monthlyReportData.LiteratureData.detailData.modernPoetry.count == null ? '-' : monthlyReportData.LiteratureData.detailData.modernPoetry.count }}</td>
                        <td>{{ monthlyReportData.LiteratureData.detailData.modernPoetry.accuracyRate == null ? '-' : monthlyReportData.LiteratureData.detailData.modernPoetry.accuracyRate + '%' }}</td>
                        <td style="text-align: right">{{ monthlyReportData.LiteratureData.detailData.modernPoetry.learningTime == null ? '-' : getTimeStringSecondsKor(monthlyReportData.LiteratureData.detailData.modernPoetry.learningTime) }}</td>
                    </tr>
                    <tr>
                        <td style="text-align: left">현대소설</td>
                        <td>{{ monthlyReportData.LiteratureData.detailData.modernNovel.count == null ? '-' : monthlyReportData.LiteratureData.detailData.modernNovel.count }}</td>
                        <td>{{ monthlyReportData.LiteratureData.detailData.modernNovel.accuracyRate == null ? '-' : monthlyReportData.LiteratureData.detailData.modernNovel.accuracyRate + '%' }}</td>
                        <td style="text-align: right">{{ monthlyReportData.LiteratureData.detailData.modernNovel.learningTime == null ? '-' : getTimeStringSecondsKor(monthlyReportData.LiteratureData.detailData.modernNovel.learningTime) }}</td>
                    </tr>
                    <tr>
                        <td style="text-align: left">고전시가</td>
                        <td>{{ monthlyReportData.LiteratureData.detailData.classicalPoetry.count == null ? '-' : monthlyReportData.LiteratureData.detailData.classicalPoetry.count }}</td>
                        <td>{{ monthlyReportData.LiteratureData.detailData.classicalPoetry.accuracyRate == null ? '-' : monthlyReportData.LiteratureData.detailData.classicalPoetry.accuracyRate + '%' }}</td>
                        <td style="text-align: right">
                            {{ monthlyReportData.LiteratureData.detailData.classicalPoetry.learningTime == null ? '-' : getTimeStringSecondsKor(monthlyReportData.LiteratureData.detailData.classicalPoetry.learningTime) }}
                        </td>
                    </tr>
                    <tr>
                        <td style="text-align: left">고전산문</td>
                        <td>{{ monthlyReportData.LiteratureData.detailData.classicalProse.count == null ? '-' : monthlyReportData.LiteratureData.detailData.classicalProse.count }}</td>
                        <td>{{ monthlyReportData.LiteratureData.detailData.classicalProse.accuracyRate == null ? '-' : monthlyReportData.LiteratureData.detailData.classicalProse.accuracyRate + '%' }}</td>
                        <td style="text-align: right">{{ monthlyReportData.LiteratureData.detailData.classicalProse.learningTime == null ? '-' : getTimeStringSecondsKor(monthlyReportData.LiteratureData.detailData.classicalProse.learningTime) }}</td>
                    </tr>
                    <tr>
                        <td style="text-align: left">극·수필</td>
                        <td>{{ monthlyReportData.LiteratureData.detailData.essay.count == null ? '-' : monthlyReportData.LiteratureData.detailData.essay.count }}</td>
                        <td>{{ monthlyReportData.LiteratureData.detailData.essay.accuracyRate == null ? '-' : monthlyReportData.LiteratureData.detailData.essay.accuracyRate + '%' }}</td>
                        <td style="text-align: right">{{ monthlyReportData.LiteratureData.detailData.essay.learningTime == null ? '-' : getTimeStringSecondsKor(monthlyReportData.LiteratureData.detailData.essay.learningTime) }}</td>
                    </tr>
                    <tr>
                        <td rowspan="7">비문학</td>
                        <td rowspan="7">
                            <span class="emphasis">{{ monthlyReportData.NonLiteratureData.accuracyRate == null ? '-' : monthlyReportData.NonLiteratureData.accuracyRate + '%' }}</span>
                        </td>
                        <td style="text-align: left">인문</td>
                        <td>{{ monthlyReportData.NonLiteratureData.detailData.humanities.count == null ? '-' : monthlyReportData.NonLiteratureData.detailData.humanities.count }}</td>
                        <td>{{ monthlyReportData.NonLiteratureData.detailData.humanities.accuracyRate == null ? '-' : monthlyReportData.NonLiteratureData.detailData.humanities.accuracyRate + '%' }}</td>
                        <td style="text-align: right">{{ monthlyReportData.NonLiteratureData.detailData.humanities.learningTime == null ? '-' : getTimeStringSecondsKor(monthlyReportData.NonLiteratureData.detailData.humanities.learningTime) }}</td>
                    </tr>
                    <tr>
                        <td style="text-align: left">과학</td>
                        <td>{{ monthlyReportData.NonLiteratureData.detailData.science.count == null ? '-' : monthlyReportData.NonLiteratureData.detailData.science.count }}</td>
                        <td>{{ monthlyReportData.NonLiteratureData.detailData.science.accuracyRate == null ? '-' : monthlyReportData.NonLiteratureData.detailData.science.accuracyRate + '%' }}</td>
                        <td style="text-align: right">{{ monthlyReportData.NonLiteratureData.detailData.science.learningTime == null ? '-' : getTimeStringSecondsKor(monthlyReportData.NonLiteratureData.detailData.science.learningTime) }}</td>
                    </tr>
                    <tr>
                        <td style="text-align: left">정치·사회</td>
                        <td>{{ monthlyReportData.NonLiteratureData.detailData.society.count == null ? '-' : monthlyReportData.NonLiteratureData.detailData.society.count }}</td>
                        <td>{{ monthlyReportData.NonLiteratureData.detailData.society.accuracyRate == null ? '-' : monthlyReportData.NonLiteratureData.detailData.society.accuracyRate + '%' }}</td>
                        <td style="text-align: right">{{ monthlyReportData.NonLiteratureData.detailData.society.learningTime == null ? '-' : getTimeStringSecondsKor(monthlyReportData.NonLiteratureData.detailData.society.learningTime) }}</td>
                    </tr>
                    <tr>
                        <td style="text-align: left">예술</td>
                        <td>{{ monthlyReportData.NonLiteratureData.detailData.art.count == null ? '-' : monthlyReportData.NonLiteratureData.detailData.art.count }}</td>
                        <td>{{ monthlyReportData.NonLiteratureData.detailData.art.accuracyRate == null ? '-' : monthlyReportData.NonLiteratureData.detailData.art.accuracyRate + '%' }}</td>
                        <td style="text-align: right">{{ monthlyReportData.NonLiteratureData.detailData.art.learningTime == null ? '-' : getTimeStringSecondsKor(monthlyReportData.NonLiteratureData.detailData.art.learningTime) }}</td>
                    </tr>
                    <tr>
                        <td style="text-align: left">기술</td>
                        <td>{{ monthlyReportData.NonLiteratureData.detailData.technology.count == null ? '-' : monthlyReportData.NonLiteratureData.detailData.technology.count }}</td>
                        <td>{{ monthlyReportData.NonLiteratureData.detailData.technology.accuracyRate == null ? '-' : monthlyReportData.NonLiteratureData.detailData.technology.accuracyRate + '%' }}</td>
                        <td style="text-align: right">{{ monthlyReportData.NonLiteratureData.detailData.technology.learningTime == null ? '-' : getTimeStringSecondsKor(monthlyReportData.NonLiteratureData.detailData.technology.learningTime) }}</td>
                    </tr>
                    <tr>
                        <td style="text-align: left">경제·문화</td>
                        <td>{{ monthlyReportData.NonLiteratureData.detailData.economy.count == null ? '-' : monthlyReportData.NonLiteratureData.detailData.economy.count }}</td>
                        <td>{{ monthlyReportData.NonLiteratureData.detailData.economy.accuracyRate == null ? '-' : monthlyReportData.NonLiteratureData.detailData.economy.accuracyRate + '%' }}</td>
                        <td style="text-align: right">{{ monthlyReportData.NonLiteratureData.detailData.economy.learningTime == null ? '-' : getTimeStringSecondsKor(monthlyReportData.NonLiteratureData.detailData.economy.learningTime) }}</td>
                    </tr>
                    <tr>
                        <td style="text-align: left">융합</td>
                        <td>{{ monthlyReportData.NonLiteratureData.detailData.fusion.count == null ? '-' : monthlyReportData.NonLiteratureData.detailData.fusion.count }}</td>
                        <td>{{ monthlyReportData.NonLiteratureData.detailData.fusion.accuracyRate == null ? '-' : monthlyReportData.NonLiteratureData.detailData.fusion.accuracyRate + '%' }}</td>
                        <td style="text-align: right">{{ monthlyReportData.NonLiteratureData.detailData.fusion.learningTime == null ? '-' : getTimeStringSecondsKor(monthlyReportData.NonLiteratureData.detailData.fusion.learningTime) }}</td>
                    </tr>
                </tbody>
            </table>
        </section>

        <section class="report__section learning-detail print-break">
            <h3 class="report__section__title">월간 학습 상세 분석</h3>
            <section class="learning-detail__part reading">
                <h4 class="part__title">지문 읽기 및 이해 활동</h4>
                <p class="part__desc">
                    {{ monthlyPieChartResult }}
                </p>
                <div class="contents__wrap">
                    <div class="contents">
                        <span class="contents__title">문학</span>
                        <div class="doughnut-chart" v-if="literatureDataCount !== 0"><PieChart :LiteratureData="literaturePieChartData" /></div>
                        <div class="doughnut-chart" v-else>데이터 없음</div>
                        <div class="contents__data">
                            <Help class="btn__view-detail">
                                <div class="pd_left_20">
                                    <ul class="mark__list">
                                        <li style="list-style: disc">핵심 소재 및 내용 파악 : 핵심어 및 지문의 주요 내용을 묻는 활동</li>
                                        <li style="list-style: disc">중심 내용 파악 및 구조화 : 지문에서 중요하게 다뤄지는 표현 또는 문장을 직접 찾아보는 활동 / 지문의 주요 내용을 구조화하여 정리하는 활동</li>
                                        <li style="list-style: disc">주제 및 핵심 표현 정리 : 지문의 주제, 지문 전반에서 사용된 핵심 표현법 등을 묻는 활동</li>
                                    </ul>
                                </div>
                            </Help>
                            <dl>
                                <dt>• 핵심 소재 및 내용 파악</dt>
                                <dd v-if="literatureDataCount !== 0">{{ literaturePieChartDetail.coreMaterial }}%</dd>
                                <dd v-else>-</dd>
                            </dl>
                            <dl>
                                <dt>• 중심 내용 파악 및 구조화</dt>
                                <dd v-if="literatureDataCount !== 0">완료</dd>
                                <dd v-else>-</dd>
                            </dl>
                            <dl>
                                <dt>• 주제 및 핵심 표현 정리</dt>
                                <dd v-if="literatureDataCount !== 0">{{ literaturePieChartDetail.topicsAndKeyPoints }}%</dd>
                                <dd v-else>-</dd>
                            </dl>
                        </div>
                    </div>
                    <div class="contents">
                        <span class="contents__title">비문학</span>
                        <div class="doughnut-chart" v-if="nonLiteratureDataCount !== 0"><PieChart :NonLiteratureData="nonLiteraturePieChartData" /></div>
                        <div class="doughnut-chart" v-else>데이터 없음</div>
                        <div class="contents__data">
                            <dl>
                                <dt>• 핵심 소재 및 내용 파악</dt>
                                <dd v-if="nonLiteratureDataCount !== 0">{{ nonLiteraturePieChartDetail.coreMaterial }}%</dd>
                                <dd v-else>-</dd>
                            </dl>
                            <dl>
                                <dt>• 중심 내용 파악 및 구조화</dt>
                                <dd v-if="nonLiteratureDataCount !== 0">완료</dd>
                                <dd v-else>-</dd>
                            </dl>
                            <dl>
                                <dt>• 주제 및 핵심 표현 정리</dt>
                                <dd v-if="nonLiteratureDataCount !== 0">{{ nonLiteraturePieChartDetail.topicsAndKeyPoints }}%</dd>
                                <dd v-else>-</dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </section>
            <section class="learning-detail__part achievement print-break">
                <h4 class="part__title">문항 난이도별 드릴 비중 및 성취율</h4>
                <p class="part__desc">{{ monthlyLiteratureStackAxesStickChartDetail }}</p>
                <div class="contents__wrap">
                    <div class="contents">
                        <span class="contents__title">문학</span>
                        <div class="line-chart__wrap">
                            <span class="chart__title">• 성취율(%)</span>
                            <div class="line-chart" v-if="literatureDataCount !== 0">
                                <StackAxesChart :LiteratureLineData="literatureStackAxesChartDetail" />
                            </div>
                            <div class="line-chart" v-else>데이터 없음</div>
                        </div>
                        <div class="column-chart__wrap">
                            <span class="chart__title">• 출제율(%)</span>
                            <div class="column-chart" v-if="literatureDataCount !== 0">
                                <StackAxesChart :LiteratureStickData="literatureStackAxesStickChartDetail" />
                            </div>
                            <div class="column-chart" v-else>데이터 없음</div>
                        </div>
                    </div>
                    <div class="contents">
                        <span class="contents__title">비문학</span>
                        <div class="line-chart__wrap">
                            <span class="chart__title">• 성취율(%)</span>
                            <div class="line-chart" v-if="nonLiteratureDataCount !== 0">
                                <StackAxesChart :NonLiteratureLineData="nonLiteratureStackAxesChartDetail" />
                            </div>
                            <div class="line-chart" v-else>데이터 없음</div>
                        </div>
                        <div class="column-chart__wrap">
                            <span class="chart__title">• 출제율(%)</span>
                            <div class="column-chart" v-if="nonLiteratureDataCount !== 0">
                                <StackAxesChart :NonLiteratureSticData="nonLiteratureStackAxesStickChartDetail" />
                            </div>
                            <div class="column-chart" v-else>데이터 없음</div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="learning-detail__part strength print-break">
                <h4 class="part__title">사고 유형별 강약점</h4>
                <p class="part__desc">{{ monthlyStrengthsAndWeaknessesResult }}</p>
                <div class="contents__wrap">
                    <div class="contents">
                        <div class="column-chart">
                            <columChart v-if="strengthsAndWeaknesses[0].value1 !== null || strengthsAndWeaknesses[1].value1 !== null || strengthsAndWeaknesses[2].value1 !== null" :chartData="strengthsAndWeaknesses" />
                        </div>
                    </div>
                </div>
            </section>
            <section class="learning-detail__part strength">
                <h4 class="part__title">질문 유형별 강약점</h4>
                <p class="part__desc">{{ monthlyQuestuionStrengthsAndWeaknesses }}</p>
                <div class="contents__wrap">
                    <div class="contents">
                        <div class="column-chart">
                            <columChart
                                v-if="questuionStrengthsAndWeaknesses[0].value1 !== null || questuionStrengthsAndWeaknesses[1].value1 !== null || questuionStrengthsAndWeaknesses[2].value1 !== null"
                                :chartData="questuionStrengthsAndWeaknesses"
                            />
                        </div>
                    </div>
                </div>
            </section>
            <section class="learning-detail__part strength">
                <h4 class="part__title">어휘 기초력</h4>
                <p class="part__desc">
                    {{ monthlyVocabularyBasics }}
                </p>
                <div class="contents__wrap">
                    <div class="contents">
                        <div class="column-chart">
                            <columChart v-if="vocabularyBasics[0].value1 !== null || vocabularyBasics[1].value1 !== null || vocabularyBasics[2].value1 !== null" :chartData="vocabularyBasics" />
                        </div>
                    </div>
                </div>
            </section>
        </section>
    </div>
</template>

<script setup>
import { computed, onBeforeMount, reactive, ref, defineProps } from 'vue';
import GaugeChart from '@/components/chart/monthylGaugeChart.vue';
import PieChart from '@/components/chart/pieChart.vue';
import StackAxesChart from '@/components/chart/StackAxesChart.vue';
import columChart from '@/components/chart/monthylColumChart.vue';
import { getTimeStringSecondsKor } from '@/helpers/utils';
import { GlobalStore } from '@/store';
import Help from '@/components/quasar/help.vue';
import Comm from '@/components/common.js';

const gStore = GlobalStore();

const props = defineProps({
    reportData: {
        default: null,
    },
    isListItem: { default: false },
});

const monthlyReportData = reactive({
    AnalysisResult: {
        issueDate: null, //날짜
        caleDate: null, //기간
        totalAccuracyRate: null, //차트 밑 % , 평균 독해력(?)
        caleAccuracyRate: null, //전월대비 독해력
        literaturePoint: null, //문학 독해력 성취율
        nonLiteraturePoint: null, //비문학 독해력 성취율
        passageCount: null, //학습한 지문 수
        correctCount: null, //학습한 문항 수
        averageKreadScore: null, //평균 크리드 지수
    },
    LiteratureData: {
        accuracyRate: null,
        detailData: {
            modernPoetry: {
                count: null,
                accuracyRate: null,
                learningTime: null,
            },
            modernNovel: {
                count: null,
                accuracyRate: null,
                learningTime: null,
            },
            classicalPoetry: {
                count: null,
                accuracyRate: null,
                learningTime: null,
            },
            classicalProse: {
                count: null,
                accuracyRate: null,
                learningTime: null,
            },
            essay: {
                count: null,
                accuracyRate: null,
                learningTime: null,
            },
        },
    },
    NonLiteratureData: {
        accuracyRate: null,
        detailData: {
            humanities: {
                count: null,
                accuracyRate: null,
                learningTime: null,
            },
            science: {
                count: null,
                accuracyRate: null,
                learningTime: null,
            },
            society: {
                count: null,
                accuracyRate: null,
                learningTime: null,
            },
            art: {
                count: null,
                accuracyRate: null,
                learningTime: null,
            },
            technology: {
                count: null,
                accuracyRate: null,
                learningTime: null,
            },
            economy: {
                count: null,
                accuracyRate: null,
                learningTime: null,
            },
            fusion: {
                count: null,
                accuracyRate: null,
                learningTime: null,
            },
        },
    },
});
const detailMapping = {
    현대시: 'modernPoetry',
    현대소설: 'modernNovel',
    고전시가: 'classicalPoetry',
    고전산문: 'classicalProse',
    극수필: 'essay',
    인문: 'humanities',
    과학: 'science',
    정치사회: 'society',
    예술: 'art',
    기술: 'technology',
    경제문화: 'economy',
    융합: 'fusion',
};

const literaturePieChartData = reactive([
    {
        name: '주의',
        percent: null,
    },
    {
        name: '권장 시간 초과',
        percent: null,
    },
    {
        name: '권장 시간 준수',
        percent: null,
    },
]);

const nonLiteraturePieChartData = reactive([
    {
        name: '주의',
        percent: null,
    },
    {
        name: '권장 시간 초과',
        percent: null,
    },
    {
        name: '권장 시간 준수',
        percent: null,
    },
]);

const literaturePieChartDetail = reactive({
    coreMaterial: null,
    mainContent: '완료',
    topicsAndKeyPoints: null,
});

const nonLiteraturePieChartDetail = reactive({
    coreMaterial: null,
    mainContent: '완료',
    topicsAndKeyPoints: null,
});

const literatureStackAxesChartDetail = reactive({
    deepening: null,
    mainPoint: null,
    basic: null,
});

const nonLiteratureStackAxesChartDetail = reactive({
    deepening: null,
    mainPoint: null,
    basic: null,
});

const literatureStackAxesStickChartDetail = reactive({
    deepening: null,
    mainPoint: null,
    basic: null,
});

const nonLiteratureStackAxesStickChartDetail = reactive({
    deepening: null,
    mainPoint: null,
    basic: null,
});

const strengthsAndWeaknesses = reactive([
    {
        category: '사실적 독해',
        value1: null,
        total: 0,
    },
    {
        category: '추론적 독해',
        value1: null,
        total: 0,
    },
    {
        category: '비판적 독해',
        value1: null,
        total: 0,
    },
    {
        category: '감상적 독해',
        value1: null,
        total: 0,
    },
    {
        category: '개념',
        value1: null,
        total: 0,
    },
    {
        category: '어휘',
        value1: null,
        total: 0,
    },
]);

const questuionStrengthsAndWeaknesses = reactive([
    {
        category: '전체 내용을\n  묻는 질문',
        value1: null,
        total: 0,
    },
    {
        category: '세부 내용을\n  묻는 질문',
        value1: null,
        total: 0,
    },
    {
        category: '긍정형 질문',
        value1: null,
        total: 0,
    },
    {
        category: '부정형 질문',
        value1: null,
        total: 0,
    },
    {
        category: '<보기>있는 질문',
        value1: null,
        total: 0,
    },
    {
        category: '<보기>없는 질문',
        value1: null,
        total: 0,
    },
]);
const vocabularyBasics = reactive([
    {
        category: '어휘의 사전적\n   의미 파악',
        value1: null,
        total: 0,
    },
    {
        category: '예문을 통한 어휘의\n       쓰임 파악',
        value1: null,
        total: 0,
    },
    {
        category: '바꾸어 쓸 어휘의\n    적정성 파악',
        value1: null,
        total: 0,
    },
    {
        category: '사자성어를 통한\n     어휘 확장',
        value1: null,
        total: 0,
    },
]);
let literatureDataCount = ref(0);
let nonLiteratureDataCount = ref(0);
let monthlyTotalResult = ref('');
let monthlyPieChartResult = ref('');
let monthlyLiteratureTimeOverData = reactive([]);
let monthlyNonLiteratureTimeOverData = reactive([]);
let monthlyLiteratureStackAxesStickChartDetail = ref('');
let monthlyStrengthsAndWeaknessesResult = ref('');
let monthlyQuestuionStrengthsAndWeaknesses = ref('');
let monthlyVocabularyBasics = ref('');
const comSchoolAndGrade = computed(() => Comm.getStrSchoolAndGrade());
onBeforeMount(() => {
    //2023-01-01 pby 재반영 확인
    if (props.reportData) {
        monthlyReportData.AnalysisResult.issueDate = props.reportData.setDate;
        monthlyReportData.AnalysisResult.caleDate = props.reportData.findDate;
        props.reportData.data.forEach((element, idx) => {
            if (idx == 0) {
                monthlyReportData.AnalysisResult.totalAccuracyRate = element.accuracy_rate;
                const caleAccuracyRate = element.accuracy_rate - element.befor_accuracy_rate;
                monthlyReportData.AnalysisResult.caleAccuracyRate = caleAccuracyRate;
                monthlyReportData.AnalysisResult.passageCount = element.learning_passage_count;
                monthlyReportData.AnalysisResult.correctCount = element.learning_problem_count;
                monthlyReportData.AnalysisResult.averageKreadScore = element.kread_avg;
                literaturePieChartDetail.coreMaterial = element.analysis5090_01_rate;
                literaturePieChartDetail.topicsAndKeyPoints = element.analysis5092_01_rate;
                nonLiteraturePieChartDetail.coreMaterial = element.analysis5090_02_rate;
                nonLiteraturePieChartDetail.topicsAndKeyPoints = element.analysis5092_02_rate;
                literatureStackAxesChartDetail.deepening = element.tc_01_rate;
                literatureStackAxesChartDetail.mainPoint = element.tb_01_rate;
                literatureStackAxesChartDetail.basic = element.ta_01_rate;
                nonLiteratureStackAxesChartDetail.deepening = element.tc_02_rate;
                nonLiteratureStackAxesChartDetail.mainPoint = element.tb_02_rate;
                nonLiteratureStackAxesChartDetail.basic = element.ta_02_rate;
                literatureStackAxesStickChartDetail.deepening = element.problem_01_tc_rate;
                literatureStackAxesStickChartDetail.mainPoint = element.problem_01_tb_rate;
                literatureStackAxesStickChartDetail.basic = element.problem_01_ta_rate;
                nonLiteratureStackAxesStickChartDetail.deepening = element.problem_02_tc_rate;
                nonLiteratureStackAxesStickChartDetail.mainPoint = element.problem_02_tb_rate;
                nonLiteratureStackAxesStickChartDetail.basic = element.problem_02_ta_rate;
                strengthsAndWeaknesses[0].value1 = element.analysis5077_rate;
                strengthsAndWeaknesses[0].total = element.analysis5077_total;
                strengthsAndWeaknesses[1].value1 = element.analysis5078_rate;
                strengthsAndWeaknesses[1].total = element.analysis5078_total;
                strengthsAndWeaknesses[2].value1 = element.analysis5079_rate;
                strengthsAndWeaknesses[2].total = element.analysis5079_total;
                strengthsAndWeaknesses[3].value1 = element.analysis5085_rate;
                strengthsAndWeaknesses[3].total = element.analysis5085_total;
                strengthsAndWeaknesses[4].value1 = element.analysis5080_rate;
                strengthsAndWeaknesses[4].total = element.analysis5080_total;
                strengthsAndWeaknesses[5].value1 = element.analysis5081_rate;
                strengthsAndWeaknesses[5].total = element.analysis5081_total;
                questuionStrengthsAndWeaknesses[0].value1 = element.type_all_rate;
                questuionStrengthsAndWeaknesses[0].total = element.type_all_total;
                questuionStrengthsAndWeaknesses[1].value1 = element.type_part_rate;
                questuionStrengthsAndWeaknesses[1].total = element.type_part_total;
                questuionStrengthsAndWeaknesses[2].value1 = element.type_positive_rate;
                questuionStrengthsAndWeaknesses[2].total = element.type_positive_total;
                questuionStrengthsAndWeaknesses[3].value1 = element.type_negative_rate;
                questuionStrengthsAndWeaknesses[3].total = element.type_negative_total;
                questuionStrengthsAndWeaknesses[4].value1 = element.type_option_exist_rate;
                questuionStrengthsAndWeaknesses[4].total = element.type_option_exist_total;
                questuionStrengthsAndWeaknesses[5].value1 = element.type_option_none_rate;
                questuionStrengthsAndWeaknesses[5].total = element.type_option_none_total;
                vocabularyBasics[0].value1 = element.analysis5093_rate;
                vocabularyBasics[0].total = element.analysis5093_total;
                vocabularyBasics[1].value1 = element.analysis5094_rate;
                vocabularyBasics[1].total = element.analysis5094_total;
                vocabularyBasics[2].value1 = element.analysis5095_rate;
                vocabularyBasics[2].total = element.analysis5095_total;
                vocabularyBasics[3].value1 = element.analysis5096_rate;
                vocabularyBasics[3].total = element.analysis5096_total;
            } else {
                if (element.area_code == '01') {
                    monthlyReportData.LiteratureData.accuracyRate += element.accuracy_rate;
                    monthlyReportData.LiteratureData.detailData[detailMapping[element.detail_code_name]].count = element.detail_count;
                    monthlyReportData.LiteratureData.detailData[detailMapping[element.detail_code_name]].accuracyRate = element.accuracy_rate;
                    monthlyReportData.LiteratureData.detailData[detailMapping[element.detail_code_name]].learningTime = element.learning_time / 1000;
                    literaturePieChartData[0].percent += element.read_time_warn_rate;
                    literaturePieChartData[1].percent += element.read_time_over_rate;
                    literaturePieChartData[2].percent += element.lread_time_ok_rate;

                    if (element.read_time_over_rate !== 0) monthlyLiteratureTimeOverData.push(element.detail_code_name);

                    literatureDataCount.value++;
                } else {
                    monthlyReportData.NonLiteratureData.accuracyRate += element.accuracy_rate;
                    monthlyReportData.NonLiteratureData.detailData[detailMapping[element.detail_code_name]].count = element.detail_count;
                    monthlyReportData.NonLiteratureData.detailData[detailMapping[element.detail_code_name]].accuracyRate = element.accuracy_rate;
                    monthlyReportData.NonLiteratureData.detailData[detailMapping[element.detail_code_name]].learningTime = element.learning_time / 1000;
                    nonLiteraturePieChartData[0].percent += element.read_time_warn_rate;
                    nonLiteraturePieChartData[1].percent += element.read_time_over_rate;
                    nonLiteraturePieChartData[2].percent += element.lread_time_ok_rate;

                    if (element.read_time_over_rate !== 0) monthlyNonLiteratureTimeOverData.push(element.detail_code_name);

                    nonLiteratureDataCount.value++;
                }
            }
        });
        //2023-01-01 pby 재반영 확인
        if (literatureDataCount.value !== 0) {
            literaturePieChartData[0].percent = literaturePieChartData[0].percent / literatureDataCount.value;
            literaturePieChartData[1].percent = literaturePieChartData[1].percent / literatureDataCount.value;
            literaturePieChartData[2].percent = literaturePieChartData[2].percent / literatureDataCount.value;
            monthlyReportData.LiteratureData.accuracyRate = Math.round(monthlyReportData.LiteratureData.accuracyRate / literatureDataCount.value);
        }

        if (nonLiteratureDataCount.value !== 0) {
            nonLiteraturePieChartData[0].percent = nonLiteraturePieChartData[0].percent / nonLiteratureDataCount.value;
            nonLiteraturePieChartData[1].percent = nonLiteraturePieChartData[1].percent / nonLiteratureDataCount.value;
            nonLiteraturePieChartData[2].percent = nonLiteraturePieChartData[2].percent / nonLiteratureDataCount.value;
            monthlyReportData.NonLiteratureData.accuracyRate = Math.round(monthlyReportData.NonLiteratureData.accuracyRate / nonLiteratureDataCount.value);
        }
    }
    //2023-01-01 반영 확인
    monthlyTotalResult.value =
        gStore.userInfo.studentName +
        ' 학생은 지난 한 달간 ' +
        monthlyReportData.AnalysisResult?.passageCount +
        '개 지문과 ' +
        monthlyReportData.AnalysisResult?.correctCount +
        '개의 문항을 풀이했으며, 학습한 지문의 평균 KReaD지수는' +
        monthlyReportData.AnalysisResult?.averageKreadScore +
        ' 입니다. ' +
        monthlyReportData.AnalysisResult.issueDate +
        '의 독해력 성취율은 ' +
        monthlyReportData.AnalysisResult?.totalAccuracyRate +
        '%로, ';
    if (monthlyReportData.LiteratureData.accuracyRate == null && monthlyReportData.NonLiteratureData.accuracyRate !== null) {
        monthlyTotalResult.value += '비문학 영역만 학습하였습니다.';
    } else if (monthlyReportData.LiteratureData.accuracyRate !== null && monthlyReportData.NonLiteratureData.accuracyRate == null) {
        monthlyTotalResult.value += '문학 영역만 학습하였습니다.';
    } else if (monthlyReportData.LiteratureData.accuracyRate <= 50 && monthlyReportData.NonLiteratureData.accuracyRate <= 50) {
        monthlyTotalResult.value += '문학 영역과 비문학 영역의 성취율이 모두 낮게 나타났습니다.';
    } else if (monthlyReportData.LiteratureData.accuracyRate >= 80 && monthlyReportData.NonLiteratureData.accuracyRate >= 80) {
        monthlyTotalResult.value += '문학 영역과 비문학 영역의 성취율이 모두 높게 나타났습니다.';
    } else if (monthlyReportData.LiteratureData.accuracyRate <= 80 && monthlyReportData.LiteratureData.accuracyRate >= 50 && monthlyReportData.NonLiteratureData.accuracyRate <= 80 && monthlyReportData.NonLiteratureData.accuracyRate >= 50) {
        monthlyTotalResult.value += '문학 영역과 비문학 영역의 성취율이 모두 평균 수준으로 나타났습니다.';
    } else if (monthlyReportData.LiteratureData.accuracyRate !== monthlyReportData.NonLiteratureData.accuracyRate && monthlyReportData.LiteratureData.accuracyRate >= monthlyReportData.NonLiteratureData.accuracyRate) {
        monthlyTotalResult.value += '문학 영역의 성취율이 비문학 영역에 비해 높게 나타났습니다.';
    } else {
        monthlyTotalResult.value += '비문학 영역의 성취율이 문학 영역에 비해 높게 나타났습니다.';
    }
    //2023-01-01 반영 확인
    if (monthlyReportData.LiteratureData.accuracyRate !== null) {
        monthlyTotalResult.value += ' 문학 성취율을 살펴보면 ';
        if (
            monthlyReportData.LiteratureData.detailData.modernPoetry.accuracyRate >= 80 ||
            monthlyReportData.LiteratureData.detailData.modernNovel.accuracyRate >= 80 ||
            monthlyReportData.LiteratureData.detailData.classicalPoetry.accuracyRate >= 80 ||
            monthlyReportData.LiteratureData.detailData.classicalProse.accuracyRate >= 80 ||
            monthlyReportData.LiteratureData.detailData.essay.accuracyRate >= 80
        ) {
            if (monthlyReportData.LiteratureData.detailData.modernPoetry.accuracyRate >= 80) {
                monthlyTotalResult.value += '현대시, ';
            }

            if (monthlyReportData.LiteratureData.detailData.modernNovel.accuracyRate >= 80) {
                monthlyTotalResult.value += '현대 소설, ';
            }

            if (monthlyReportData.LiteratureData.detailData.classicalPoetry.accuracyRate >= 80) {
                monthlyTotalResult.value += '고전 시가, ';
            }

            if (monthlyReportData.LiteratureData.detailData.classicalProse.accuracyRate >= 80) {
                monthlyTotalResult.value += '고전 산문, ';
            }

            if (monthlyReportData.LiteratureData.detailData.essay.accuracyRate >= 80) {
                monthlyTotalResult.value += '극·수필, ';
            }

            monthlyTotalResult.value = monthlyTotalResult.value.substr(0, monthlyTotalResult.value.lastIndexOf(',')) + ' 지문의 성취율이 높습니다. ';

            console.log('높습니다 데이터');
        }

        if (
            (monthlyReportData.LiteratureData.detailData.modernPoetry.accuracyRate < 80 && monthlyReportData.LiteratureData.detailData.modernPoetry.accuracyRate >= 50) ||
            (monthlyReportData.LiteratureData.detailData.modernNovel.accuracyRate < 80 && monthlyReportData.LiteratureData.detailData.modernNovel.accuracyRate >= 50) ||
            (monthlyReportData.LiteratureData.detailData.classicalPoetry.accuracyRate < 80 && monthlyReportData.LiteratureData.detailData.classicalPoetry.accuracyRate >= 50) ||
            (monthlyReportData.LiteratureData.detailData.classicalProse.accuracyRate < 80 && monthlyReportData.LiteratureData.detailData.classicalProse.accuracyRate >= 50) ||
            (monthlyReportData.LiteratureData.detailData.essay.accuracyRate < 80 && monthlyReportData.LiteratureData.detailData.essay.accuracyRate >= 50)
        ) {
            if (monthlyReportData.LiteratureData.detailData.modernPoetry.accuracyRate < 80 && monthlyReportData.LiteratureData.detailData.modernPoetry.accuracyRate >= 50) {
                monthlyTotalResult.value += '현대시, ';
            }

            if (monthlyReportData.LiteratureData.detailData.modernNovel.accuracyRate < 80 && monthlyReportData.LiteratureData.detailData.modernNovel.accuracyRate >= 50) {
                monthlyTotalResult.value += '현대 소설, ';
            }

            if (monthlyReportData.LiteratureData.detailData.classicalPoetry.accuracyRate < 80 && monthlyReportData.LiteratureData.detailData.classicalPoetry.accuracyRate >= 50) {
                monthlyTotalResult.value += '고전 시가, ';
            }

            if (monthlyReportData.LiteratureData.detailData.classicalProse.accuracyRate < 80 && monthlyReportData.LiteratureData.detailData.classicalProse.accuracyRate >= 50) {
                monthlyTotalResult.value += '고전 산문, ';
            }

            if (monthlyReportData.LiteratureData.detailData.essay.accuracyRate < 80 && monthlyReportData.LiteratureData.detailData.essay.accuracyRate >= 50) {
                monthlyTotalResult.value += '극·수필, ';
            }

            monthlyTotalResult.value = monthlyTotalResult.value.substr(0, monthlyTotalResult.value.lastIndexOf(',')) + ' 지문의 성취율이 평균 수준입니다. ';
        }

        if (
            (monthlyReportData.LiteratureData.detailData.modernPoetry.accuracyRate < 50 && monthlyReportData.LiteratureData.detailData.modernPoetry.accuracyRate !== null) ||
            (monthlyReportData.LiteratureData.detailData.modernNovel.accuracyRate < 50 && monthlyReportData.LiteratureData.detailData.modernNovel.accuracyRate !== null) ||
            (monthlyReportData.LiteratureData.detailData.classicalPoetry.accuracyRate < 50 && monthlyReportData.LiteratureData.detailData.classicalPoetry.accuracyRate !== null) ||
            (monthlyReportData.LiteratureData.detailData.classicalProse.accuracyRate < 50 && monthlyReportData.LiteratureData.detailData.classicalProse.accuracyRate !== null) ||
            (monthlyReportData.LiteratureData.detailData.essay.accuracyRate < 50 && monthlyReportData.LiteratureData.detailData.essay.accuracyRate !== null)
        ) {
            if (monthlyReportData.LiteratureData.detailData.modernPoetry.accuracyRate < 50 && monthlyReportData.LiteratureData.detailData.modernPoetry.accuracyRate !== null) {
                monthlyTotalResult.value += '현대시, ';
            }

            if (monthlyReportData.LiteratureData.detailData.modernNovel.accuracyRate < 50 && monthlyReportData.LiteratureData.detailData.modernNovel.accuracyRate !== null) {
                monthlyTotalResult.value += '현대 소설, ';
            }

            if (monthlyReportData.LiteratureData.detailData.classicalPoetry.accuracyRate < 50 && monthlyReportData.LiteratureData.detailData.classicalPoetry.accuracyRate !== null) {
                monthlyTotalResult.value += '고전 시가, ';
            }

            if (monthlyReportData.LiteratureData.detailData.classicalProse.accuracyRate < 50 && monthlyReportData.LiteratureData.detailData.classicalProse.accuracyRate !== null) {
                monthlyTotalResult.value += '고전 산문, ';
            }

            if (monthlyReportData.LiteratureData.detailData.essay.accuracyRate < 50 && monthlyReportData.LiteratureData.detailData.essay.accuracyRate !== null) {
                monthlyTotalResult.value += '극·수필, ';
            }
            console.log('monthlyTotalResult.value', monthlyTotalResult.value);

            monthlyTotalResult.value = monthlyTotalResult.value.substr(0, monthlyTotalResult.value.lastIndexOf(',')) + ' 지문의 성취율이 낮습니다. ';
        }
    }

    //2023-01-01 반영 확인
    if (monthlyReportData.NonLiteratureData.accuracyRate !== null) {
        monthlyTotalResult.value += '비문학의 성취율을 살펴보면 ';
        if (
            monthlyReportData.NonLiteratureData.detailData.humanities.accuracyRate >= 80 ||
            monthlyReportData.NonLiteratureData.detailData.science.accuracyRate >= 80 ||
            monthlyReportData.NonLiteratureData.detailData.society.accuracyRate >= 80 ||
            monthlyReportData.NonLiteratureData.detailData.art.accuracyRate >= 80 ||
            monthlyReportData.NonLiteratureData.detailData.technology.accuracyRate >= 80 ||
            monthlyReportData.NonLiteratureData.detailData.economy.accuracyRate >= 80 ||
            monthlyReportData.NonLiteratureData.detailData.fusion.accuracyRate >= 80
        ) {
            if (monthlyReportData.NonLiteratureData.detailData.humanities.accuracyRate >= 80) {
                monthlyTotalResult.value += '인문, ';
            }

            if (monthlyReportData.NonLiteratureData.detailData.science.accuracyRate >= 80) {
                monthlyTotalResult.value += '과학, ';
            }

            if (monthlyReportData.NonLiteratureData.detailData.society.accuracyRate >= 80) {
                monthlyTotalResult.value += '정치·사회, ';
            }

            if (monthlyReportData.NonLiteratureData.detailData.art.accuracyRate >= 80) {
                monthlyTotalResult.value += '예술, ';
            }

            if (monthlyReportData.NonLiteratureData.detailData.technology.accuracyRate >= 80) {
                monthlyTotalResult.value += '기술, ';
            }

            if (monthlyReportData.NonLiteratureData.detailData.economy.accuracyRate >= 80) {
                monthlyTotalResult.value += '경제·문화, ';
            }

            if (monthlyReportData.NonLiteratureData.detailData.fusion.accuracyRate >= 80) {
                monthlyTotalResult.value += '융합, ';
            }

            monthlyTotalResult.value = monthlyTotalResult.value.substr(0, monthlyTotalResult.value.lastIndexOf(',')) + ' 지문의 성취율이 높습니다. ';
        }
        if (
            (monthlyReportData.NonLiteratureData.detailData.humanities.accuracyRate < 80 && monthlyReportData.NonLiteratureData.detailData.humanities.accuracyRate >= 50) ||
            (monthlyReportData.NonLiteratureData.detailData.science.accuracyRate < 80 && monthlyReportData.NonLiteratureData.detailData.science.accuracyRate >= 50) ||
            (monthlyReportData.NonLiteratureData.detailData.society.accuracyRate < 80 && monthlyReportData.NonLiteratureData.detailData.society.accuracyRate >= 50) ||
            (monthlyReportData.NonLiteratureData.detailData.art.accuracyRate < 80 && monthlyReportData.NonLiteratureData.detailData.art.accuracyRate >= 50) ||
            (monthlyReportData.NonLiteratureData.detailData.technology.accuracyRate < 80 && monthlyReportData.NonLiteratureData.detailData.technology.accuracyRate >= 50) ||
            (monthlyReportData.NonLiteratureData.detailData.economy.accuracyRate < 80 && monthlyReportData.NonLiteratureData.detailData.economy.accuracyRate >= 50) ||
            (monthlyReportData.NonLiteratureData.detailData.fusion.accuracyRate < 80 && monthlyReportData.NonLiteratureData.detailData.fusion.accuracyRate >= 50)
        ) {
            if (monthlyReportData.NonLiteratureData.detailData.humanities.accuracyRate < 80 && monthlyReportData.NonLiteratureData.detailData.humanities.accuracyRate >= 50) {
                monthlyTotalResult.value += '인문, ';
            }

            if (monthlyReportData.NonLiteratureData.detailData.science.accuracyRate < 80 && monthlyReportData.NonLiteratureData.detailData.science.accuracyRate >= 50) {
                monthlyTotalResult.value += '과학, ';
            }

            if (monthlyReportData.NonLiteratureData.detailData.society.accuracyRate < 80 && monthlyReportData.NonLiteratureData.detailData.society.accuracyRate >= 50) {
                monthlyTotalResult.value += '정치·사회, ';
            }

            if (monthlyReportData.NonLiteratureData.detailData.art.accuracyRate < 80 && monthlyReportData.NonLiteratureData.detailData.art.accuracyRate >= 50) {
                monthlyTotalResult.value += '예술, ';
            }

            if (monthlyReportData.NonLiteratureData.detailData.technology.accuracyRate < 80 && monthlyReportData.NonLiteratureData.detailData.technology.accuracyRate >= 50) {
                monthlyTotalResult.value += '기술, ';
            }

            if (monthlyReportData.NonLiteratureData.detailData.economy.accuracyRate < 80 && monthlyReportData.NonLiteratureData.detailData.economy.accuracyRate >= 50) {
                monthlyTotalResult.value += '경제·문화, ';
            }

            if (monthlyReportData.NonLiteratureData.detailData.fusion.accuracyRate < 80 && monthlyReportData.NonLiteratureData.detailData.fusion.accuracyRate >= 50) {
                monthlyTotalResult.value += '융합, ';
            }

            monthlyTotalResult.value = monthlyTotalResult.value.substr(0, monthlyTotalResult.value.lastIndexOf(',')) + ' 지문의 성취율이 평균 수준입니다. ';
        }
        if (
            (monthlyReportData.NonLiteratureData.detailData.humanities.accuracyRate < 50 && monthlyReportData.NonLiteratureData.detailData.humanities.accuracyRate !== null) ||
            (monthlyReportData.NonLiteratureData.detailData.science.accuracyRate < 50 && monthlyReportData.NonLiteratureData.detailData.science.accuracyRate !== null) ||
            (monthlyReportData.NonLiteratureData.detailData.society.accuracyRate < 50 && monthlyReportData.NonLiteratureData.detailData.society.accuracyRate !== null) ||
            (monthlyReportData.NonLiteratureData.detailData.art.accuracyRate < 50 && monthlyReportData.NonLiteratureData.detailData.art.accuracyRate !== null) ||
            (monthlyReportData.NonLiteratureData.detailData.technology.accuracyRate < 50 && monthlyReportData.NonLiteratureData.detailData.technology.accuracyRate !== null) ||
            (monthlyReportData.NonLiteratureData.detailData.economy.accuracyRate < 50 && monthlyReportData.NonLiteratureData.detailData.economy.accuracyRate !== null) ||
            (monthlyReportData.NonLiteratureData.detailData.fusion.accuracyRate < 50 && monthlyReportData.NonLiteratureData.detailData.fusion.accuracyRate !== null)
        ) {
            if (monthlyReportData.NonLiteratureData.detailData.humanities.accuracyRate < 50 && monthlyReportData.NonLiteratureData.detailData.humanities.accuracyRate !== null) {
                monthlyTotalResult.value += '인문, ';
            }

            if (monthlyReportData.NonLiteratureData.detailData.science.accuracyRate < 50 && monthlyReportData.NonLiteratureData.detailData.science.accuracyRate !== null) {
                monthlyTotalResult.value += '과학, ';
            }

            if (monthlyReportData.NonLiteratureData.detailData.society.accuracyRate < 50 && monthlyReportData.NonLiteratureData.detailData.society.accuracyRate !== null) {
                monthlyTotalResult.value += '정치·사회, ';
            }

            if (monthlyReportData.NonLiteratureData.detailData.art.accuracyRate < 50 && monthlyReportData.NonLiteratureData.detailData.art.accuracyRate !== null) {
                monthlyTotalResult.value += '예술, ';
            }

            if (monthlyReportData.NonLiteratureData.detailData.technology.accuracyRate < 50 && monthlyReportData.NonLiteratureData.detailData.technology.accuracyRate !== null) {
                monthlyTotalResult.value += '기술, ';
            }

            if (monthlyReportData.NonLiteratureData.detailData.economy.accuracyRate < 50 && monthlyReportData.NonLiteratureData.detailData.economy.accuracyRate !== null) {
                monthlyTotalResult.value += '경제·문화, ';
            }

            if (monthlyReportData.NonLiteratureData.detailData.fusion.accuracyRate < 50 && monthlyReportData.NonLiteratureData.detailData.fusion.accuracyRate !== null) {
                monthlyTotalResult.value += '융합, ';
            }

            monthlyTotalResult.value = monthlyTotalResult.value.substr(0, monthlyTotalResult.value.lastIndexOf(',')) + ' 지문의 성취율이 낮습니다. ';
        }
    }
    //2023-01-01 반영 확인
    monthlyTotalResult.value += '수능에서는 다양한 갈래, 주제의 지문이 출제되므로 골고루 학습해 두는 것이 좋습니다. ';
    monthlyTotalResult.value += '문항별로 살펴보면, ';
    if (
        strengthsAndWeaknesses[0].value1 >= 80 ||
        strengthsAndWeaknesses[1].value1 >= 80 ||
        strengthsAndWeaknesses[2].value1 >= 80 ||
        strengthsAndWeaknesses[3].value1 >= 80 ||
        strengthsAndWeaknesses[4].value1 >= 80 ||
        strengthsAndWeaknesses[5].value1 >= 80 ||
        questuionStrengthsAndWeaknesses[0].value1 >= 80 ||
        questuionStrengthsAndWeaknesses[1].value1 >= 80 ||
        questuionStrengthsAndWeaknesses[2].value1 >= 80 ||
        questuionStrengthsAndWeaknesses[3].value1 >= 80 ||
        questuionStrengthsAndWeaknesses[4].value1 >= 80 ||
        questuionStrengthsAndWeaknesses[5].value1 >= 80
    ) {
        if (strengthsAndWeaknesses[0].value1 >= 80) {
            monthlyTotalResult.value += '사실적 독해, ';
        }

        if (strengthsAndWeaknesses[1].value1 >= 80) {
            monthlyTotalResult.value += '추론적 독해, ';
        }

        if (strengthsAndWeaknesses[2].value1 >= 80) {
            monthlyTotalResult.value += '비판적 독해, ';
        }

        if (strengthsAndWeaknesses[3].value1 >= 80) {
            monthlyTotalResult.value += '감상적 독해, ';
        }

        if (strengthsAndWeaknesses[4].value1 >= 80) {
            monthlyTotalResult.value += '개념, ';
        }

        if (strengthsAndWeaknesses[5].value1 >= 80) {
            monthlyTotalResult.value += '어휘, ';
        }

        if (questuionStrengthsAndWeaknesses[0].value1 >= 80) {
            monthlyTotalResult.value += '전체 내용을 묻는 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[1].value1 >= 80) {
            monthlyTotalResult.value += '세부 내용을 묻는 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[2].value1 >= 80) {
            monthlyTotalResult.value += '긍정형 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[3].value1 >= 80) {
            monthlyTotalResult.value += '부정형 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[4].value1 >= 80) {
            monthlyTotalResult.value += '<보기>있는 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[5].value1 >= 80) {
            monthlyTotalResult.value += '<보기>없는 질문, ';
        }

        monthlyTotalResult.value = monthlyTotalResult.value.substr(0, monthlyTotalResult.value.lastIndexOf(',')) + ' 유형의 문제 해결력이 우수합니다. ';
    }
    if (
        (strengthsAndWeaknesses[0].value1 < 80 && strengthsAndWeaknesses[0].value1 >= 50) ||
        (strengthsAndWeaknesses[1].value1 < 80 && strengthsAndWeaknesses[1].value1 >= 50) ||
        (strengthsAndWeaknesses[2].value1 < 80 && strengthsAndWeaknesses[2].value1 >= 50) ||
        (strengthsAndWeaknesses[3].value1 < 80 && strengthsAndWeaknesses[3].value1 >= 50) ||
        (strengthsAndWeaknesses[4].value1 < 80 && strengthsAndWeaknesses[4].value1 >= 50) ||
        (strengthsAndWeaknesses[5].value1 < 80 && strengthsAndWeaknesses[5].value1 >= 50) ||
        (questuionStrengthsAndWeaknesses[0].value1 < 80 && questuionStrengthsAndWeaknesses[0].value1 >= 50) ||
        (questuionStrengthsAndWeaknesses[1].value1 < 80 && questuionStrengthsAndWeaknesses[1].value1 >= 50) ||
        (questuionStrengthsAndWeaknesses[2].value1 < 80 && questuionStrengthsAndWeaknesses[2].value1 >= 50) ||
        (questuionStrengthsAndWeaknesses[3].value1 < 80 && questuionStrengthsAndWeaknesses[3].value1 >= 50) ||
        (questuionStrengthsAndWeaknesses[4].value1 < 80 && questuionStrengthsAndWeaknesses[4].value1 >= 50) ||
        (questuionStrengthsAndWeaknesses[5].value1 < 80 && questuionStrengthsAndWeaknesses[5].value1 >= 50)
    ) {
        if (strengthsAndWeaknesses[0].value1 < 80 && strengthsAndWeaknesses[0].value1 >= 50) {
            monthlyTotalResult.value += '사실적 독해, ';
        }

        if (strengthsAndWeaknesses[1].value1 < 80 && strengthsAndWeaknesses[1].value1 >= 50) {
            monthlyTotalResult.value += '추론적 독해, ';
        }

        if (strengthsAndWeaknesses[2].value1 < 80 && strengthsAndWeaknesses[2].value1 >= 50) {
            monthlyTotalResult.value += '비판적 독해, ';
        }

        if (strengthsAndWeaknesses[3].value1 < 80 && strengthsAndWeaknesses[3].value1 >= 50) {
            monthlyTotalResult.value += '감상적 독해, ';
        }

        if (strengthsAndWeaknesses[4].value1 < 80 && strengthsAndWeaknesses[4].value1 >= 50) {
            monthlyTotalResult.value += '개념, ';
        }

        if (strengthsAndWeaknesses[5].value1 < 80 && strengthsAndWeaknesses[5].value1 >= 50) {
            monthlyTotalResult.value += '어휘, ';
        }

        if (questuionStrengthsAndWeaknesses[0].value1 < 80 && questuionStrengthsAndWeaknesses[0].value1 >= 50) {
            monthlyTotalResult.value += '전체 내용을 묻는 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[1].value1 < 80 && questuionStrengthsAndWeaknesses[1].value1 >= 50) {
            monthlyTotalResult.value += '세부 내용을 묻는 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[2].value1 < 80 && questuionStrengthsAndWeaknesses[2].value1 >= 50) {
            monthlyTotalResult.value += '긍정형 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[3].value1 < 80 && questuionStrengthsAndWeaknesses[3].value1 >= 50) {
            monthlyTotalResult.value += '부정형 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[4].value1 < 80 && questuionStrengthsAndWeaknesses[4].value1 >= 50) {
            monthlyTotalResult.value += '<보기>있는 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[5].value1 < 80 && questuionStrengthsAndWeaknesses[5].value1 >= 50) {
            monthlyTotalResult.value += '<보기>없는 질문, ';
        }

        monthlyTotalResult.value = monthlyTotalResult.value.substr(0, monthlyTotalResult.value.lastIndexOf(',')) + ' 유형의 문제 해결력이 평균 수준입니다. ';
    }
    if (
        (strengthsAndWeaknesses[0].value1 < 50 && strengthsAndWeaknesses[0].total > 0) ||
        (strengthsAndWeaknesses[1].value1 < 50 && strengthsAndWeaknesses[1].total > 0) ||
        (strengthsAndWeaknesses[2].value1 < 50 && strengthsAndWeaknesses[2].total > 0) ||
        (strengthsAndWeaknesses[3].value1 < 50 && strengthsAndWeaknesses[3].total > 0) ||
        (strengthsAndWeaknesses[4].value1 < 50 && strengthsAndWeaknesses[4].total > 0) ||
        (strengthsAndWeaknesses[5].value1 < 50 && strengthsAndWeaknesses[5].total > 0) ||
        (questuionStrengthsAndWeaknesses[0].value1 < 50 && questuionStrengthsAndWeaknesses[0].total > 0) ||
        (questuionStrengthsAndWeaknesses[1].value1 < 50 && questuionStrengthsAndWeaknesses[1].total > 0) ||
        (questuionStrengthsAndWeaknesses[2].value1 < 50 && questuionStrengthsAndWeaknesses[2].total > 0) ||
        (questuionStrengthsAndWeaknesses[3].value1 < 50 && questuionStrengthsAndWeaknesses[3].total > 0) ||
        (questuionStrengthsAndWeaknesses[4].value1 < 50 && questuionStrengthsAndWeaknesses[4].total > 0) ||
        (questuionStrengthsAndWeaknesses[5].value1 < 50 && questuionStrengthsAndWeaknesses[5].total > 0)
    ) {
        if (strengthsAndWeaknesses[0].value1 < 50 && strengthsAndWeaknesses[0].total > 0) {
            monthlyTotalResult.value += '사실적 독해, ';
        }

        if (strengthsAndWeaknesses[1].value1 < 50 && strengthsAndWeaknesses[1].total > 0) {
            monthlyTotalResult.value += '추론적 독해, ';
        }

        if (strengthsAndWeaknesses[2].value1 < 50 && strengthsAndWeaknesses[2].total > 0) {
            monthlyTotalResult.value += '비판적 독해, ';
        }

        if (strengthsAndWeaknesses[3].value1 < 50 && strengthsAndWeaknesses[3].total > 0) {
            monthlyTotalResult.value += '감상적 독해, ';
        }

        if (strengthsAndWeaknesses[4].value1 < 50 && strengthsAndWeaknesses[4].total > 0) {
            monthlyTotalResult.value += '개념, ';
        }

        if (strengthsAndWeaknesses[5].value1 < 50 && strengthsAndWeaknesses[5].total > 0) {
            monthlyTotalResult.value += '어휘, ';
        }

        if (questuionStrengthsAndWeaknesses[0].value1 < 50 && questuionStrengthsAndWeaknesses[0].total > 0) {
            monthlyTotalResult.value += '전체 내용을 묻는 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[1].value1 < 50 && questuionStrengthsAndWeaknesses[1].total > 0) {
            monthlyTotalResult.value += '세부 내용을 묻는 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[2].value1 < 50 && questuionStrengthsAndWeaknesses[2].total > 0) {
            monthlyTotalResult.value += '긍정형 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[3].value1 < 50 && questuionStrengthsAndWeaknesses[3].total > 0) {
            monthlyTotalResult.value += '부정형 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[4].value1 < 50 && questuionStrengthsAndWeaknesses[4].total > 0) {
            monthlyTotalResult.value += '<보기>있는 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[5].value1 < 50 && questuionStrengthsAndWeaknesses[5].total > 0) {
            monthlyTotalResult.value += '<보기>없는 질문, ';
        }

        monthlyTotalResult.value = monthlyTotalResult.value.substr(0, monthlyTotalResult.value.lastIndexOf(',')) + ' 유형의 문제 해결력이 취약합니다.';
    }
    //2023-01-01 반영 확인
    monthlyPieChartResult.value = '지문을 읽을 때 ';
    if (literatureDataCount.value !== 0) {
        monthlyPieChartResult.value += '문학에서 ';
        if (literaturePieChartData[0].percent >= literaturePieChartData[1].percent && literaturePieChartData[0].percent >= literaturePieChartData[2].percent) {
            monthlyPieChartResult.value += '권장 독해 시간 기준에 미달한 비중, ';
        }

        if (literaturePieChartData[1].percent >= literaturePieChartData[0].percent && literaturePieChartData[1].percent >= literaturePieChartData[2].percent) {
            monthlyPieChartResult.value += '권장 독해 시간 기준을 초과한 비중, ';
        }

        if (literaturePieChartData[2].percent >= literaturePieChartData[1].percent && literaturePieChartData[2].percent >= literaturePieChartData[0].percent) {
            monthlyPieChartResult.value += '권장 독해 시간 기준을 준수한 비중, ';
        }
    }
    //2023-01-01 반영 확인
    if (nonLiteratureDataCount.value !== 0) {
        monthlyPieChartResult.value += ' 비문학에서 ';
        if (nonLiteraturePieChartData[0].percent >= nonLiteraturePieChartData[1].percent && nonLiteraturePieChartData[0].percent >= nonLiteraturePieChartData[2].percent) {
            monthlyPieChartResult.value += '권장 독해 시간 기준에 미달한 비중, ';
        }

        if (nonLiteraturePieChartData[1].percent >= nonLiteraturePieChartData[0].percent && nonLiteraturePieChartData[1].percent >= nonLiteraturePieChartData[2].percent) {
            monthlyPieChartResult.value += '권장 독해 시간 기준을 초과한 비중, ';
        }

        if (nonLiteraturePieChartData[2].percent >= nonLiteraturePieChartData[1].percent && nonLiteraturePieChartData[2].percent >= nonLiteraturePieChartData[0].percent) {
            monthlyPieChartResult.value += '권장 독해 시간 기준을 준수한 비중, ';
        }
    }
    monthlyPieChartResult.value = monthlyPieChartResult.value.substr(0, monthlyPieChartResult.value.lastIndexOf(',')) + '이 높았습니다.';
    if (monthlyLiteratureTimeOverData.length > 0 || monthlyNonLiteratureTimeOverData.length > 0) {
        monthlyPieChartResult.value += ' 특히 시간초과 비중이 높은 것은 ';
        if (monthlyLiteratureTimeOverData.length > 0) {
            monthlyLiteratureTimeOverData.forEach((el) => {
                monthlyPieChartResult.value += el + ', ';
            });
        }
        if (monthlyNonLiteratureTimeOverData.length > 0) {
            monthlyNonLiteratureTimeOverData.forEach((el) => {
                monthlyPieChartResult.value += el + ', ';
            });
        }
        monthlyPieChartResult.value = monthlyPieChartResult.value.substr(0, monthlyPieChartResult.value.lastIndexOf(',')) + '입니다.';
    }
    monthlyPieChartResult.value += ' 지문을 적정 시간에 정확하게 읽어내는 트레이닝을 꾸준히 하면, 향후 수능에서도 지문과 문항 풀이에 대한 시간 배분을 효율적으로 할 수 있습니다.';
    //2023-01-01 반영 확인
    if (literatureDataCount.value.value !== 0) {
        monthlyLiteratureStackAxesStickChartDetail.value += '문학의 심화 문항을 풀이한 비중은 전체 문항의 ' + literatureStackAxesStickChartDetail.deepening + '%이고, 성취율은 ' + literatureStackAxesChartDetail.deepening + '%로 ';
        if (literatureStackAxesChartDetail.deepening >= 80) {
            monthlyLiteratureStackAxesStickChartDetail.value += '높은 편입니다.';
        } else if (literatureStackAxesChartDetail.deepening >= 50 && literatureStackAxesChartDetail.deepening < 80) {
            monthlyLiteratureStackAxesStickChartDetail.value += '평균 수준입니다.';
        } else if (literatureStackAxesChartDetail.deepening < 50) {
            monthlyLiteratureStackAxesStickChartDetail.value += '낮은 편입니다.';
        }
    }

    if (nonLiteratureDataCount.value !== 0) {
        monthlyLiteratureStackAxesStickChartDetail.value += ' 비문학의 심화 문항을 풀이한 비중은 전체 문항의 ' + nonLiteratureStackAxesStickChartDetail.deepening + '%이고, 성취율은 ' + nonLiteratureStackAxesChartDetail.deepening + '%로 ';
        if (nonLiteratureStackAxesChartDetail.deepening >= 80) {
            monthlyLiteratureStackAxesStickChartDetail.value += '높은 편입니다.';
        } else if (nonLiteratureStackAxesChartDetail.deepening >= 50 && nonLiteratureStackAxesChartDetail.deepening < 80) {
            monthlyLiteratureStackAxesStickChartDetail.value += '평균 수준입니다.';
        } else if (nonLiteratureStackAxesChartDetail.deepening < 50) {
            monthlyLiteratureStackAxesStickChartDetail.value += '낮은 편입니다.';
        }
    }

    if (literatureStackAxesStickChartDetail.deepening >= 30 || nonLiteratureStackAxesStickChartDetail.deepening >= 30 || literatureStackAxesChartDetail.deepening >= 50 || nonLiteratureStackAxesChartDetail.deepening >= 50) {
        monthlyLiteratureStackAxesStickChartDetail.value += ' 심화 문항의 출제 비중과 성취율이 모두 높을수록 독해 실력이 우수하다는 것을 의미합니다.';
    } else {
        monthlyLiteratureStackAxesStickChartDetail.value +=
            ' 심화 문항의 출제 비중과 성취율이 모두 높을수록 독해 실력이 우수하다는 것을 의미합니다. 심화 문항의 출제 비중이 30% 미만이거나 성취율이 50% 미만이면, 마이노트의 심화노트를 학습하며 난이도 높은 문항에 대한 감각을 키워 주는 것이 좋습니다.';
    }
    //2023-01-01 반영 확인
    monthlyStrengthsAndWeaknessesResult.value = '사고 유형별 강약점을 살펴보면 ';
    if (
        strengthsAndWeaknesses[0].value1 >= 80 ||
        strengthsAndWeaknesses[1].value1 >= 80 ||
        strengthsAndWeaknesses[2].value1 >= 80 ||
        strengthsAndWeaknesses[3].value1 >= 80 ||
        strengthsAndWeaknesses[4].value1 >= 80 ||
        strengthsAndWeaknesses[5].value1 >= 80
    ) {
        if (strengthsAndWeaknesses[0].value1 >= 80) {
            monthlyStrengthsAndWeaknessesResult.value += '사실적 독해, ';
        }

        if (strengthsAndWeaknesses[1].value1 >= 80) {
            monthlyStrengthsAndWeaknessesResult.value += '추론적 독해, ';
        }

        if (strengthsAndWeaknesses[2].value1 >= 80) {
            monthlyStrengthsAndWeaknessesResult.value += '비판적 독해, ';
        }

        if (strengthsAndWeaknesses[3].value1 >= 80) {
            monthlyStrengthsAndWeaknessesResult.value += '감상적 독해, ';
        }

        if (strengthsAndWeaknesses[4].value1 >= 80) {
            monthlyStrengthsAndWeaknessesResult.value += '개념, ';
        }

        if (strengthsAndWeaknesses[5].value1 >= 80) {
            monthlyStrengthsAndWeaknessesResult.value += '어휘, ';
        }

        monthlyStrengthsAndWeaknessesResult.value = monthlyStrengthsAndWeaknessesResult.value.substr(0, monthlyStrengthsAndWeaknessesResult.value.lastIndexOf(',')) + ' 유형의 성취율이 높습니다. ';
    }
    if (
        (strengthsAndWeaknesses[0].value1 < 80 && strengthsAndWeaknesses[0].value1 >= 50) ||
        (strengthsAndWeaknesses[1].value1 < 80 && strengthsAndWeaknesses[1].value1 >= 50) ||
        (strengthsAndWeaknesses[2].value1 < 80 && strengthsAndWeaknesses[2].value1 >= 50) ||
        (strengthsAndWeaknesses[3].value1 < 80 && strengthsAndWeaknesses[3].value1 >= 50) ||
        (strengthsAndWeaknesses[4].value1 < 80 && strengthsAndWeaknesses[4].value1 >= 50) ||
        (strengthsAndWeaknesses[5].value1 < 80 && strengthsAndWeaknesses[5].value1 >= 50)
    ) {
        if (strengthsAndWeaknesses[0].value1 < 80 && strengthsAndWeaknesses[0].value1 >= 50) {
            monthlyStrengthsAndWeaknessesResult.value += '사실적 독해, ';
        }

        if (strengthsAndWeaknesses[1].value1 < 80 && strengthsAndWeaknesses[1].value1 >= 50) {
            monthlyStrengthsAndWeaknessesResult.value += '추론적 독해, ';
        }

        if (strengthsAndWeaknesses[2].value1 < 80 && strengthsAndWeaknesses[2].value1 >= 50) {
            monthlyStrengthsAndWeaknessesResult.value += '비판적 독해, ';
        }

        if (strengthsAndWeaknesses[3].value1 < 80 && strengthsAndWeaknesses[3].value1 >= 50) {
            monthlyStrengthsAndWeaknessesResult.value += '감상적 독해, ';
        }

        if (strengthsAndWeaknesses[4].value1 < 80 && strengthsAndWeaknesses[4].value1 >= 50) {
            monthlyStrengthsAndWeaknessesResult.value += '개념, ';
        }

        if (strengthsAndWeaknesses[5].value1 < 80 && strengthsAndWeaknesses[5].value1 >= 50) {
            monthlyStrengthsAndWeaknessesResult.value += '어휘, ';
        }

        monthlyStrengthsAndWeaknessesResult.value = monthlyStrengthsAndWeaknessesResult.value.substr(0, monthlyStrengthsAndWeaknessesResult.value.lastIndexOf(',')) + ' 유형의 성취율이 평균 수준입니다. ';
    }
    if (
        (strengthsAndWeaknesses[0].value1 < 50 && strengthsAndWeaknesses[0].total > 0) ||
        (strengthsAndWeaknesses[1].value1 < 50 && strengthsAndWeaknesses[1].total > 0) ||
        (strengthsAndWeaknesses[2].value1 < 50 && strengthsAndWeaknesses[2].total > 0) ||
        (strengthsAndWeaknesses[3].value1 < 50 && strengthsAndWeaknesses[3].total > 0) ||
        (strengthsAndWeaknesses[4].value1 < 50 && strengthsAndWeaknesses[4].total > 0) ||
        (strengthsAndWeaknesses[5].value1 < 50 && strengthsAndWeaknesses[5].total > 0)
    ) {
        if (strengthsAndWeaknesses[0].value1 < 50 && strengthsAndWeaknesses[0].total > 0) {
            monthlyStrengthsAndWeaknessesResult.value += '사실적 독해, ';
        }

        if (strengthsAndWeaknesses[1].value1 < 50 && strengthsAndWeaknesses[1].total > 0) {
            monthlyStrengthsAndWeaknessesResult.value += '추론적 독해, ';
        }

        if (strengthsAndWeaknesses[2].value1 < 50 && strengthsAndWeaknesses[2].total > 0) {
            monthlyStrengthsAndWeaknessesResult.value += '비판적 독해, ';
        }

        if (strengthsAndWeaknesses[3].value1 < 50 && strengthsAndWeaknesses[3].total > 0) {
            monthlyStrengthsAndWeaknessesResult.value += '감상적 독해, ';
        }

        if (strengthsAndWeaknesses[4].value1 < 50 && strengthsAndWeaknesses[4].total > 0) {
            monthlyStrengthsAndWeaknessesResult.value += '개념, ';
        }

        if (strengthsAndWeaknesses[5].value1 < 50 && strengthsAndWeaknesses[5].total > 0) {
            monthlyStrengthsAndWeaknessesResult.value += '어휘, ';
        }

        monthlyStrengthsAndWeaknessesResult.value = monthlyStrengthsAndWeaknessesResult.value.substr(0, monthlyStrengthsAndWeaknessesResult.value.lastIndexOf(',')) + ' 유형의 성취율이 낮습니다.';
    }
    //2023-01-01 반영 확인
    monthlyQuestuionStrengthsAndWeaknesses.value = '질문 유형별 강약점을 살펴보면 ';

    if (
        questuionStrengthsAndWeaknesses[0].value1 >= 80 ||
        questuionStrengthsAndWeaknesses[1].value1 >= 80 ||
        questuionStrengthsAndWeaknesses[2].value1 >= 80 ||
        questuionStrengthsAndWeaknesses[3].value1 >= 80 ||
        questuionStrengthsAndWeaknesses[4].value1 >= 80 ||
        questuionStrengthsAndWeaknesses[5].value1 >= 80
    ) {
        if (questuionStrengthsAndWeaknesses[0].value1 >= 80) {
            monthlyQuestuionStrengthsAndWeaknesses.value += '전체 내용을 묻는 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[1].value1 >= 80) {
            monthlyQuestuionStrengthsAndWeaknesses.value += '세부 내용을 묻는 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[2].value1 >= 80) {
            monthlyQuestuionStrengthsAndWeaknesses.value += '긍정형 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[3].value1 >= 80) {
            monthlyQuestuionStrengthsAndWeaknesses.value += '부정형 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[4].value1 >= 80) {
            monthlyQuestuionStrengthsAndWeaknesses.value += '<보기>있는 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[5].value1 >= 80) {
            monthlyQuestuionStrengthsAndWeaknesses.value += '<보기>없는 질문, ';
        }

        monthlyQuestuionStrengthsAndWeaknesses.value = monthlyQuestuionStrengthsAndWeaknesses.value.substr(0, monthlyQuestuionStrengthsAndWeaknesses.value.lastIndexOf(',')) + ' 유형의 성취율이 높습니다. ';
    }
    if (
        (questuionStrengthsAndWeaknesses[0].value1 < 80 && questuionStrengthsAndWeaknesses[0].value1 >= 50) ||
        (questuionStrengthsAndWeaknesses[1].value1 < 80 && questuionStrengthsAndWeaknesses[1].value1 >= 50) ||
        (questuionStrengthsAndWeaknesses[2].value1 < 80 && questuionStrengthsAndWeaknesses[2].value1 >= 50) ||
        (questuionStrengthsAndWeaknesses[3].value1 < 80 && questuionStrengthsAndWeaknesses[3].value1 >= 50) ||
        (questuionStrengthsAndWeaknesses[4].value1 < 80 && questuionStrengthsAndWeaknesses[4].value1 >= 50) ||
        (questuionStrengthsAndWeaknesses[5].value1 < 80 && questuionStrengthsAndWeaknesses[5].value1 >= 50)
    ) {
        if (questuionStrengthsAndWeaknesses[0].value1 < 80 && questuionStrengthsAndWeaknesses[0].value1 >= 50) {
            monthlyQuestuionStrengthsAndWeaknesses.value += '전체 내용을 묻는 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[1].value1 < 80 && questuionStrengthsAndWeaknesses[1].value1 >= 50) {
            monthlyQuestuionStrengthsAndWeaknesses.value += '세부 내용을 묻는 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[2].value1 < 80 && questuionStrengthsAndWeaknesses[2].value1 >= 50) {
            monthlyQuestuionStrengthsAndWeaknesses.value += '긍정형 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[3].value1 < 80 && questuionStrengthsAndWeaknesses[3].value1 >= 50) {
            monthlyQuestuionStrengthsAndWeaknesses.value += '부정형 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[4].value1 < 80 && questuionStrengthsAndWeaknesses[4].value1 >= 50) {
            monthlyQuestuionStrengthsAndWeaknesses.value += '<보기>있는 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[5].value1 < 80 && questuionStrengthsAndWeaknesses[5].value1 >= 50) {
            monthlyQuestuionStrengthsAndWeaknesses.value += '<보기>없는 질문, ';
        }

        monthlyQuestuionStrengthsAndWeaknesses.value = monthlyQuestuionStrengthsAndWeaknesses.value.substr(0, monthlyQuestuionStrengthsAndWeaknesses.value.lastIndexOf(',')) + ' 유형의 성취율이 평균 수준입니다. ';
    }

    if (
        (questuionStrengthsAndWeaknesses[0].value1 < 50 && questuionStrengthsAndWeaknesses[0].total > 0) ||
        (questuionStrengthsAndWeaknesses[1].value1 < 50 && questuionStrengthsAndWeaknesses[1].total > 0) ||
        (questuionStrengthsAndWeaknesses[2].value1 < 50 && questuionStrengthsAndWeaknesses[2].total > 0) ||
        (questuionStrengthsAndWeaknesses[3].value1 < 50 && questuionStrengthsAndWeaknesses[3].total > 0) ||
        (questuionStrengthsAndWeaknesses[4].value1 < 50 && questuionStrengthsAndWeaknesses[4].total > 0) ||
        (questuionStrengthsAndWeaknesses[5].value1 < 50 && questuionStrengthsAndWeaknesses[5].total > 0)
    ) {
        if (questuionStrengthsAndWeaknesses[0].value1 < 50 && questuionStrengthsAndWeaknesses[0].total > 0) {
            monthlyQuestuionStrengthsAndWeaknesses.value += '전체 내용을 묻는 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[1].value1 < 50 && questuionStrengthsAndWeaknesses[1].total > 0) {
            monthlyQuestuionStrengthsAndWeaknesses.value += '세부 내용을 묻는 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[2].value1 < 50 && questuionStrengthsAndWeaknesses[2].total > 0) {
            monthlyQuestuionStrengthsAndWeaknesses.value += '긍정형 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[3].value1 < 50 && questuionStrengthsAndWeaknesses[3].total > 0) {
            monthlyQuestuionStrengthsAndWeaknesses.value += '부정형 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[4].value1 < 50 && questuionStrengthsAndWeaknesses[4].total > 0) {
            monthlyQuestuionStrengthsAndWeaknesses.value += '<보기>있는 질문, ';
        }

        if (questuionStrengthsAndWeaknesses[5].value1 < 50 && questuionStrengthsAndWeaknesses[5].total > 0) {
            monthlyQuestuionStrengthsAndWeaknesses.value += '<보기>없는 질문, ';
        }

        monthlyQuestuionStrengthsAndWeaknesses.value = monthlyQuestuionStrengthsAndWeaknesses.value.substr(0, monthlyQuestuionStrengthsAndWeaknesses.value.lastIndexOf(',')) + ' 유형의 성취율이 낮습니다.';
    }
    //2023-01-01 반영 확인
    monthlyVocabularyBasics.value = '어휘 기초력을 살펴 보면 ';
    if (vocabularyBasics[0].value1 >= 80 || vocabularyBasics[1].value1 >= 80 || vocabularyBasics[2].value1 >= 80 || vocabularyBasics[3].value1 >= 80) {
        if (vocabularyBasics[0].value1 >= 80) {
            monthlyVocabularyBasics.value += '어휘의 사전적 의미 파악, ';
        }

        if (vocabularyBasics[1].value1 >= 80) {
            monthlyVocabularyBasics.value += '예문을 통한 어휘의 쓰임 파악, ';
        }

        if (vocabularyBasics[2].value1 >= 80) {
            monthlyVocabularyBasics.value += '바꾸어 쓸 어휘의 적정성 파악, ';
        }

        if (vocabularyBasics[3].value1 >= 80) {
            monthlyVocabularyBasics.value += '사자성어를 통한 어휘 확장, ';
        }

        monthlyVocabularyBasics.value = monthlyVocabularyBasics.value.substr(0, monthlyVocabularyBasics.value.lastIndexOf(',')) + ' 유형의 성취율이 높습니다. ';
    }

    if (
        (vocabularyBasics[0].value1 < 80 && vocabularyBasics[0].value1 >= 50) ||
        (vocabularyBasics[1].value1 < 80 && vocabularyBasics[1].value1 >= 50) ||
        (vocabularyBasics[2].value1 < 80 && vocabularyBasics[2].value1 >= 50) ||
        (vocabularyBasics[3].value1 < 80 && vocabularyBasics[3].value1 >= 50)
    ) {
        if (vocabularyBasics[0].value1 < 80 && vocabularyBasics[0].value1 >= 50) {
            monthlyVocabularyBasics.value += '어휘의 사전적 의미 파악, ';
        }

        if (vocabularyBasics[1].value1 < 80 && vocabularyBasics[1].value1 >= 50) {
            monthlyVocabularyBasics.value += '예문을 통한 어휘의 쓰임 파악, ';
        }

        if (vocabularyBasics[2].value1 < 80 && vocabularyBasics[2].value1 >= 50) {
            monthlyVocabularyBasics.value += '바꾸어 쓸 어휘의 적정성 파악, ';
        }

        if (vocabularyBasics[3].value1 < 80 && vocabularyBasics[3].value1 >= 50) {
            monthlyVocabularyBasics.value += '사자성어를 통한 어휘 확장, ';
        }

        monthlyVocabularyBasics.value = monthlyVocabularyBasics.value.substr(0, monthlyVocabularyBasics.value.lastIndexOf(',')) + ' 유형의 성취율이 평균 수준입니다. ';
    }

    if (
        (vocabularyBasics[0].value1 < 50 && vocabularyBasics[0].total > 0) ||
        (vocabularyBasics[1].value1 < 50 && vocabularyBasics[1].total > 0) ||
        (vocabularyBasics[2].value1 < 50 && vocabularyBasics[2].total > 0) ||
        (vocabularyBasics[3].value1 < 50 && vocabularyBasics[3].total > 0)
    ) {
        if (vocabularyBasics[0].value1 < 50 && vocabularyBasics[0].total > 0) {
            monthlyVocabularyBasics.value += '어휘의 사전적 의미 파악, ';
        }

        if (vocabularyBasics[1].value1 < 50 && vocabularyBasics[1].total > 0) {
            monthlyVocabularyBasics.value += '예문을 통한 어휘의 쓰임 파악, ';
        }

        if (vocabularyBasics[2].value1 < 50 && vocabularyBasics[2].total > 0) {
            monthlyVocabularyBasics.value += '바꾸어 쓸 어휘의 적정성 파악, ';
        }

        if (vocabularyBasics[3].value1 < 50 && vocabularyBasics[3].total > 0) {
            monthlyVocabularyBasics.value += '사자성어를 통한 어휘 확장, ';
        }

        monthlyVocabularyBasics.value = monthlyVocabularyBasics.value.substr(0, monthlyVocabularyBasics.value.lastIndexOf(',')) + ' 유형의 성취율이 낮습니다. ';
    }
    //2023-01-01 반영 확인
    monthlyVocabularyBasics.value += '어휘 기초력은 수능에서 어휘 문항을 풀어 내는 능력의 기초가 되므로, 모든 유형을 고르게 상승시키는 것이 좋습니다.';
});
</script>

<style scoped>
@media print {
    * {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
    }
    .print-break {
        page-break-before: always;
        padding-top: 5vw;
    }
}
.monthly-report-print {
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
    padding: 0 5vw;
    box-sizing: border-box;
}
.monthly-report-print .report__header {
    display: flex;
    align-items: center;
    position: relative;
    padding: 5vw 0 2vw;
    border-bottom: 1px solid #e0e0e0;
    box-sizing: border-box;
}
.monthly-report-print .report__header .header__title {
    font-size: 2vw;
}
.monthly-report-print .report__overview {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 3vw;
    background-color: #e0e0e0;
    box-sizing: border-box;
}
.monthly-report-print .report__overview .overview__info .info__grade {
    display: block;
    font-size: 1.6vw;
    line-height: 150%;
}
.monthly-report-print .report__overview .overview__info .info__title {
    margin-top: 1.6vw;
    font-size: 2vw;
    line-height: 150%;
}
.monthly-report-print .report__overview .overview__info .info__date {
    position: relative;
    display: flex;
    margin-top: 2.5vw;
    font-size: 1.8vw;
    line-height: 150%;
}
.monthly-report-print .report__overview .overview__chart {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 13vw;
    margin-right: 2vw;
    padding: 3vw 4vw;
    background-color: #fff;
    border-radius: 2vw;
}
.monthly-report-print .report__overview .overview__chart .gauge-chart {
    width: 19vw;
    height: 8vw;
}
.monthly-report-print .report__overview .overview__chart .gauge-chart__wrap {
    position: relative;
    height: 9vw;
    margin-right: 1.5vw;
}
.monthly-report-print .report__overview .overview__chart .gauge-chart__data {
    position: absolute;
    left: 50%;
    bottom: -0.5vw;
    transform: translateX(-50%);
}
.monthly-report-print .report__overview .overview__chart .gauge-chart__title {
    display: flex;
    align-items: center;
    color: #000;
    font-size: 1.4vw;
}
.monthly-report-print .report__overview .overview__chart .gauge-chart__title__star {
    color: #18b73f;
}
.monthly-report-print .report__overview .overview__chart .gauge-chart__percent {
    color: #222;
    font-size: 1.2vw;
    font-weight: 600;
}
.monthly-report-print .report__overview .overview__chart .gauge-chart__percent__emphasis {
    font-size: 3.7vw;
    font-weight: 700;
    line-height: 100%;
}
.monthly-report-print .report__overview .overview__chart .chart__info {
    flex: 1;
    text-align: center;
}
.monthly-report-print .report__overview .overview__chart .chart__info dt {
    color: #666;
    font-size: 1.8vw;
    font-weight: 600;
    line-height: 150%;
}
.monthly-report-print .report__overview .overview__chart .chart__info dd {
    margin-top: 0.4vw;
    color: #222;
    font-size: 2.2vw;
    font-weight: 600;
    line-height: 150%;
}
.monthly-report-print .report__overview .overview__keyword {
    margin-top: 1.3vw;
    padding-left: 1vw;
    font-size: 1.6vw;
    line-height: 150%;
}
.monthly-report-print .report__overview .overview__keyword .keyword__star {
    color: #18b73f;
}
.monthly-report-print .report__overview .overview__keyword .keyword__title {
    display: block;
    margin-left: -0.8vw;
    margin-bottom: 0.2vw;
    font-size: 1.6vw;
    font-weight: 700;
}
.monthly-report-print .report__section {
    padding: 3vw 3vw 0 3vw;
    box-sizing: border-box;
}
.monthly-report-print .report__section__title {
    margin-bottom: 1vw;
    color: #222;
    font-size: 2vw;
    font-weight: 700;
    line-height: 150%;
}
.monthly-report-print .report__section .analyze-result__data {
    display: flex;
    flex-wrap: wrap;
    margin: -0.5vw;
}
.monthly-report-print .report__section .analyze-result__data .data {
    margin-top: 1.5vw;
    text-align: right;
    color: #666;
    font-size: 1.8vw;
    font-weight: 600;
}
.monthly-report-print .report__section .analyze-result__data .data__title {
    color: #222;
    font-size: 1.6vw;
    font-weight: 600;
}
.monthly-report-print .report__section .analyze-result__data .data__list {
    margin: 0.5vw;
    padding: 1.6vw;
    border-radius: 0.8vw;
    background: #e0e0e0;
    box-sizing: border-box;
}
.monthly-report-print .report__section .analyze-result__data .data__list:nth-child(1),
.monthly-report-print .report__section .analyze-result__data .data__list:nth-child(2),
.monthly-report-print .report__section .analyze-result__data .data__list:nth-child(3),
.monthly-report-print .report__section .analyze-result__data .data__list:nth-child(4) {
    flex: 1;
}
.monthly-report-print .report__section .analyze-result__text {
    margin-top: 2vw;
    margin-bottom: 0;
    color: #222;
    font-size: 1.4vw;
    line-height: 180%;
}
.monthly-report-print .report__section .learning-table {
    width: 100%;
}
.monthly-report-print .report__section .learning-table thead {
    border-top: 1px solid #222;
}
.monthly-report-print .report__section .learning-table tbody {
    border-bottom: 1px solid #222;
}
.monthly-report-print .report__section .learning-table tr {
    width: 100%;
}
.monthly-report-print .report__section .learning-table tr + tr {
    border-top: 1px solid #ddd;
}
.monthly-report-print .report__section .learning-table th {
    padding: 1vw 1.5vw;
    background: #e0e0e0;
    border-bottom: 1px solid #ddd;
    color: #222;
    font-size: 1.5vw;
    font-weight: 600;
    line-height: 1.6vw;
    text-align: center;
}
.monthly-report-print .report__section .learning-table td {
    padding: 1vw 1.5vw;
    color: #666;
    font-size: 1.5vw;
    font-weight: 400;
    line-height: 100%;
    text-align: center;
}
.monthly-report-print .report__section .learning-detail__part {
    margin-bottom: 4vw;
}
.monthly-report-print .report__section .learning-detail__part:last-of-type {
    margin-bottom: 0;
}
.monthly-report-print .report__section .learning-detail__part .part__title {
    position: relative;
    padding-left: 1vw;
    color: #222;
    font-size: 2vw;
    font-weight: 600;
    line-height: 150%;
}
.monthly-report-print .report__section .learning-detail__part .part__title:first-of-type {
    margin-top: 0;
}
.monthly-report-print .report__section .learning-detail__part .part__title:before {
    content: '';
    display: block;
    position: absolute;
    top: 1.4vw;
    left: 0;
    width: 0.4vw;
    height: 0.4vw;
    background-color: #000;
    border-radius: 100%;
}
.monthly-report-print .report__section .learning-detail__part .part__desc {
    margin-top: 1vw;
    padding: 0 1vw;
    color: #222;
    font-size: 1.4vw;
    font-weight: 400;
    line-height: 150%;
}
.monthly-report-print .report__section .learning-detail__part .contents {
    flex: 1;
    margin-right: 1vw;
    padding: 3vw;
    border: 1px solid #ddd;
    border-radius: 0.8vw;
    box-sizing: border-box;
}
.monthly-report-print .report__section .learning-detail__part .contents:last-of-type {
    margin-right: 0;
}
.monthly-report-print .report__section .learning-detail__part .contents__wrap {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 1.5vw;
}
.monthly-report-print .report__section .learning-detail__part .contents__title {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 4.5vw;
    background: #e0e0e0;
    border-radius: 0.4vw;
    color: #222;
    font-size: 1.8vw;
    font-weight: 700;
    line-height: 150%;
}
.monthly-report-print .report__section .learning-detail__part .contents__data {
    position: relative;
    margin-top: 4vw;
    padding: 1vw 2vw;
    background-color: #fafafa;
}
.monthly-report-print .report__section .learning-detail__part .contents__data dl {
    display: flex;
    padding: 1vw 1.2vw;
    border-bottom: 1px solid #ddd;
}
.monthly-report-print .report__section .learning-detail__part .contents__data dl:last-of-type {
    border-bottom: none;
}
.monthly-report-print .report__section .learning-detail__part .contents__data dl dt {
    width: calc(100% - 5vw);
    color: #666;
    font-size: 1.6vw;
    font-weight: 400;
    line-height: 170%;
    text-align: left;
}
.monthly-report-print .report__section .learning-detail__part .contents__data dl dd {
    color: #222;
    font-size: 1.6vw;
    font-weight: 700;
    line-height: 170%;
}
.monthly-report-print .report__section .learning-detail__part .contents__data .btn__view-detail {
    position: absolute;
    top: 0.4vw;
    right: 0.4vw;
}
.monthly-report-print .report__section .learning-detail__part .contents .doughnut-chart {
    height: 22vw;
    margin-top: 3vw;
}
.monthly-report-print .report__section .learning-detail__part.achievement .contents {
    padding-bottom: 0;
}
.monthly-report-print .report__section .learning-detail__part.achievement .chart__title {
    display: block;
    margin-top: 2vw;
    color: #18b73f;
    font-size: 1.8vw;
    font-weight: 600;
    line-height: 150%; /* 36px */
    text-align: left;
}
.monthly-report-print .report__section .learning-detail__part.achievement .line-chart {
    height: 24vw;
    margin-top: 2vw;
}
.monthly-report-print .report__section .learning-detail__part.achievement .column-chart {
    width: calc(100% - 6vw);
    height: 25vw;
    margin: 2vw auto 3vw;
}
.monthly-report-print .report__section .learning-detail__part.achievement .column-chart__wrap {
    overflow: hidden;
    position: relative;
    width: calc(100% + 6vw);
    margin-top: 2vw;
    margin-left: -3vw;
}
.monthly-report-print .report__section .learning-detail__part.achievement .column-chart__wrap:before {
    content: '';
    display: block;
    position: absolute;
    z-index: -1;
    width: 100%;
    height: 100%;
    background-color: #fafafa;
    border-radius: 0 0 0.8vw 16.8vwpx;
}
.monthly-report-print .report__section .learning-detail__part.achievement .column-chart__wrap .chart__title {
    padding-left: 3vw;
}
.monthly-report-print .report__section .strength .contents {
    height: 28vw;
    padding: 3vw 7vw;
    background-color: #fafafa;
    border: none;
}
.monthly-report-print .report__section .strength .contents .column-chart {
    width: 100%;
    height: 100%;
}
.monthly-report-print .emphasis {
    color: #18b73f;
    font-weight: 700;
}
</style>
